import { IWebPreviewExtra } from './material';

export interface IHeadPosition {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}

export enum EReferenceType {
  Style = 1, // 画风
  Avatar = 2, // 头像
}

export enum EAvatarTag {
  BaseImg = 1,
  SmallHead = 2,
  Background = 3,
  FaceImg = 4,
  UserUploadImg = 5, // 用户上传的img
}

export interface INpcAvatar {
  avatar_id?: bigint;
  avatar_img_url?: string;
  avatar_tag?: EAvatarTag;
  base_img_url?: string;
  img_desc?: string;
  avatar_head_position?: IHeadPosition;
  avatar_depth_img_url?: string;
  style_name?: string;
  lora_id?: string;
  extra?: string;
  keywords?: string[];
  new_extra_xl_model?: string;
  reference?: EReferenceType[];
  create_time?: number; // 单位毫秒
  biz_extra?: string;
  new_extra?: string;
  background_bottom_offset?: number; // 背景图偏移量 0~1
  caption?: string;
  small_thumbnail_url?: string; // 缩略图 300*0
  dominate_color?: string; // npc 聊天背景色值
  avatar_style_id?: number; // 画风id
  web_preview_extra?: IWebPreviewExtra; // web链路来的额外信息
  flux_ai_writer?: string; // flux ai生成的文案
}
